import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";
import {regionFields} from "../regions/regions.graphql";

export const districtFields = `
id
districUniqueId
districName
districPostcode
napaId
districParentRegion {
  ${regionFields}
}
`
export const GET_ALL_DISTRICTS = gql`
query GetAllDistricts($regionalUniqueId: String) {
  getAllDistricts(regionalUniqueId: $regionalUniqueId) {
    ${baseResponseGraphqlField}
    data {
      ${districtFields}
    }
  }
}
`
